import { initializeApp } from "firebase/app";
import { NextFn, Observer, deleteToken, getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";
import * as Sentry from '@sentry/react'
import { FIREBASE_CONFIG, FIREBASE_MESSAGING_CONFIG } from "./Constants";

// Firebase cloud messaging
const app = initializeApp(FIREBASE_CONFIG)


export default class PushNotification {
  static async requestPermission(): Promise<NotificationPermission | 'unsupported'> {
    if (await isSupported() === false) return 'unsupported'
    return Notification.requestPermission()
  }

  static async getToken(): Promise<string | null> {
    if (await isSupported() === false) return null

    const messaging = getMessaging(app)

    try {
      const currentToken = await getToken(messaging, FIREBASE_MESSAGING_CONFIG)

      if (currentToken) return currentToken
    } catch (ex) {
      Sentry.captureException(ex)

      // The underlying push subscription is often stale rather than the permission
      // being revoked (common on iOS PWA after a few days of inactivity). Force a
      // clean re-subscribe instead of giving up on the first failure.
      try {
        await deleteToken(messaging)
        return await getToken(messaging, FIREBASE_MESSAGING_CONFIG)
      } catch (retryEx) {
        Sentry.captureException(retryEx)
        return null
      }
    }

    return null
  }

  static async onMessage(callback: NextFn<any> | Observer<any>) {
    if (await isSupported()) {
      const messaging = getMessaging(app)
      return onMessage(messaging, callback)
    } else {
      return () => { }
    }
  }
}